import { Backdrop } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useStores } from "src/models/root-store/root-store-context";
import LoadingScreen from "./LoadingScreen";

const LoadingCircle = observer(() => {
  const { loadingStore } = useStores();

  return <Backdrop
    sx={{ color: '#fff', zIndex: 9998, }}
    open={loadingStore.loading}
  >
    <LoadingScreen
      sx={{
        width: 1,
        zIndex: 9999,
        height: 774,
        backgroundColor: "transparent"
      }}
    />
  </Backdrop>
})
export default LoadingCircle;